<template>
  <div class="">
    <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-4 gap-4">
      <div>
        <h2 class="text-xl font-semibold text-gray-800">List of consult astrology data</h2>
      </div>
    </div>
    <!-- Search Bar -->
    <div class="flex flex-wrap items-center justify-between gap-2 mb-4">
      <!-- app type -->
      <div class="flex bg-gray-200 rounded-lg">
        <button
          :class="[
            'px-4 py-2 font-medium focus:outline-none transition select-none',
            search.app_type === 'all' ? 'bg-white text-indigo-700 font-semibold shadow-md rounded-lg z-10' : 'text-gray-600 hover:bg-gray-200',
          ]"
          @click="
            search.app_type = 'all';
            fetchAllConsultAstrology();
          "
        >
          All
        </button>
        <button
          :class="[
            'px-4 py-2 font-medium focus:outline-none transition select-none',
            search.app_type === 'bharat' ? 'bg-white text-indigo-700 font-semibold shadow-md rounded-lg z-10' : 'text-gray-600 hover:bg-gray-200',
          ]"
          @click="
            search.app_type = 'bharat';
            fetchAllConsultAstrology();
          "
        >
          Bharat
        </button>
        <button
          :class="[
            'px-4 py-2 font-medium focus:outline-none transition select-none',
            search.app_type === 'samvat' ? 'bg-white text-indigo-700 font-semibold shadow-md rounded-lg z-10' : 'text-gray-600 hover:bg-gray-200',
          ]"
          @click="
            search.app_type = 'samvat';
            fetchAllConsultAstrology();
          "
        >
          Samvat
        </button>
        <button
          :class="[
            'px-4 py-2 font-medium focus:outline-none transition select-none',
            search.app_type === 'business' ? 'bg-white text-indigo-700 font-semibold shadow-md rounded-lg z-10' : 'text-gray-600 hover:bg-gray-200',
          ]"
          @click="
            search.app_type = 'business';
            fetchAllConsultAstrology();
          "
        >
          Business
        </button>
      </div>
      <!-- other filters  -->
      <div class="flex items-center gap-2">
        <vs-select v-model="search.day" @change="fetchAllConsultAstrology()" class="w-28" :color="'#6366f1'">
          <vs-select-item value="0" text="All Days" />
          <vs-select-item value="1" text="Today" />
          <vs-select-item value="7" text="This Week" />
          <vs-select-item value="30" text="This Month" />
        </vs-select>
        <!-- lang filter -->
        <vs-select v-model="search.language" @change="fetchAllConsultAstrology()" class="w-28" :color="'#6366f1'">
          <vs-select-item value="all" text="Language" disabled />
          <vs-select-item v-for="lang in languages" :key="lang.culture" :value="lang.culture" :text="lang.culture" />
        </vs-select>
        <!--  refresh button -->
        <button
          @click="resetData()"
          class="flex items-center gap-1 bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded-lg font-medium transition"
        >
          <span class="material-icons text-base">refresh</span> Reset
        </button>
      </div>
    </div>
    <!-- Table -->
    <div class="overflow-x-auto rounded-xl border border-gray-200 bg-white pb-2">
      <table class="min-w-full bg-white rounded-xl">
        <thead class="border-b">
          <tr>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">#</th>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">User Info</th>
            <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase">Consultancy</th>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">App Type</th>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">Language</th>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">Date</th>
          </tr>
          <tr
            v-for="(item, idx) in all"
            v-if="all && all.length > 0"
            :key="item._id"
            class="border-b hover:bg-gray-100 transition"
            @click="viewAllPosts(item)"
          >
            <td class="px-4 py-3">{{ idx + 1 + (current_page - 1) * data_per_page }}</td>
            <td class="td">
              <span class="flex flex-col gap-1">
                <span class="font-medium">{{ item.name }}</span>
                <span class="text-sm text-gray-500">{{ item.phone }}</span>
              </span>
            </td>
            <td class="px-4 py-3 text-center">{{ item.consultancy }}</td>
            <td class="px-4 py-3">{{ item.app_type }}</td>
            <td class="px-4 py-3">{{ item.language }}</td>
            <td class="px-4 py-3">{{ moment(item.date) }}</td>
          </tr>
        </thead>
      </table>
      <div v-if="!all || all.length === 0" class="p-4 text-center text-gray-500">No data available.</div>
    </div>
    <div class="flex flex-col md:flex-row items-center justify-between mt-3 pr-3">
      <div class="invisible">
        <span>asd</span>
      </div>
      <div class="flex justify-center items-center">
        <vs-pagination v-model="current_page" :total="total_pages_array.length" :limit="1" @change="fetchAllConsultAstrology" class="my-2" />
      </div>
      <div class="flex items-center gap-2 text-sm mt-2 md:mt-0">
        <span>Show Records:</span>
        <vs-select v-model="data_per_page" @change="fetchAllConsultAstrology" class="w-20" :color="'#6366f1'">
          <vs-select-item value="25" text="25" />
          <vs-select-item value="50" text="50" />
          <vs-select-item value="100" text="100" />
        </vs-select>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/rest.js";
import { API } from "@/common/constants";
import moment from "moment";

export default {
  name: "Consult Astrology",
  data: () => ({
    title: "Consult Astrology",
    sortByField: "",
    sortDirection: "asc",
    search: {
      language: "all",
      app_type: "all",
      day: "0",
    },
    all: [],
    total_data: 0,
    data_per_page: 25,
    page_count: 0,
    total_pages_array: [],
    current_page: 1,
    languages: [],
  }),
  //   sortedData() {
  //     if (this.sortByField) {
  //       return this.all.sort((a, b) => {
  //         if (this.sortDirection === "desc") {
  //           return a[this.sortByField] > b[this.sortByField] ? 1 : -1;
  //         } else {
  //           return a[this.sortByField] < b[this.sortByField] ? 1 : -1;
  //         }
  //       });
  //     }
  //     return this.all;
  //   },
  methods: {
    // sortByDate(field) {
    //   if (this.sortByField === field) {
    //     this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
    //   } else {
    //     this.sortByField = field;
    //     this.sortDirection = "asc";
    //   }
    //   this.all = this.sortedData;
    // },
    moment: function (date) {
      return moment.utc(date).format("DD/MM/YYYY");
    },

    async fetchAllConsultAstrology() {
      this.$vs.loading();

      try {
        const r = await api.get(API.GET_CONSULT_ASTROLOGY, {
          params: {
            page: this.$data.current_page,
            size: this.data_per_page,
            language: this.$data.search.language,
            app_type: this.$data.search.app_type,
            day: this.$data.search.day,
          },
        });

        if (r.status === 200) {
          this.$data.all = r.data.returnedData;
          this.$data.total_data = r.data.count;
          this.$data.page_count = Math.ceil(r.data.count / this.$data.data_per_page);
          this.$data.total_pages_array = [...Array(this.$data.page_count).keys()];
        }
      } catch (error) {
        this.$vs.notify({
          text: "Error fetching consult astrology data",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    handleCurrentPage(page) {
      this.$data.current_page = page;
      this.fetchAllConsultAstrology();
    },

    handleClicked(page) {
      if (this.$data.current_page === page) {
        this.$data.button_css = "clicked";
      } else {
        this.$data.button_css = "not-clicked";
      }
    },

    resetData() {
      this.$data.current_page = 1;
      this.$data.data_per_page = 25;
      this.$data.search = {
        language: "all",
        app_type: "all",
        day: "0",
      };
      this.fetchAllConsultAstrology();
    },

    async fetchAllLanguages() {
      this.$vs.loading();
      try {
        const r = await await api.get(API.GET_LANG, {});
        this.languages = r.data;
      } catch (error) {
        this.$vs.notify({
          text: "Error fetching languages",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  async created() {
    if (!this.$data.search.language) this.$data.search.language = "all";

    await Promise.all([this.fetchAllConsultAstrology(), this.fetchAllLanguages()]);
  },
};
</script>

<style scoped>
.material-icons {
  font-family: "Material Icons";
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  direction: ltr;
  -webkit-font-smoothing: antialiased;
}
</style>
